import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
const toneClass = {
    neutral: 'bg-muted text-muted-foreground',
    success: 'bg-success-muted text-success',
    warning: 'bg-warning-muted text-warning',
    danger: 'bg-danger-muted text-danger',
    info: 'bg-info-muted text-info'
};
/** Compact categorical label; use StatusPill when the value represents state. */ export const SpecraTag = /*#__PURE__*/ React.forwardRef(({ children, className, icon, onRemove, removeButtonProps, removeLabel = 'Remove tag', tone = 'neutral', ...props }, ref)=>/*#__PURE__*/ _jsxs("span", {
        className: cn('inline-flex items-center gap-[var(--space-1)] whitespace-nowrap rounded-[var(--radius-sm)] px-[var(--space-1-5)] py-[var(--space-0-5)] text-[length:var(--fs-ui-micro)] font-medium uppercase leading-none tracking-[var(--ls-ui-label)]', toneClass[tone], className),
        ref: ref,
        ...props,
        children: [
            icon ? /*#__PURE__*/ _jsx("span", {
                "aria-hidden": "true",
                children: icon
            }) : null,
            children,
            onRemove ? /*#__PURE__*/ _jsx("button", {
                "aria-label": removeLabel,
                ...removeButtonProps,
                className: cn('-mr-[var(--space-0-5)] inline-flex rounded-[var(--radius-xs)] p-[var(--space-0-5)] hover:bg-foreground/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring', removeButtonProps?.className),
                onClick: (event)=>{
                    event.stopPropagation();
                    onRemove();
                },
                type: "button",
                children: /*#__PURE__*/ _jsx("span", {
                    "aria-hidden": "true",
                    children: "×"
                })
            }) : null
        ]
    }));
SpecraTag.displayName = 'SpecraTag';
